import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/select-dealer/banner_back.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section
      className="banner_pick banner_dealer"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#fff" }}>
              Select Dealer Service Website Development
            </h1>
            <p style={{ color: "#fff" }}>
              Going digital is no more option businesses have, however at
              TekRevol, we believe in going the extra mile and creating websites
              that leave a lasting impression on audiences.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="banner_select">
              <StaticImage
                src="../../../images/case-studies/select-dealer/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={922}
                height={743}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
